import { CommonModule } from '@angular/common';
import { Component, effect, inject, Input } from '@angular/core';
import { ButtonComponent } from './button';
import { LocaleService } from 'src/app/services/locale';

@Component({
  selector: 'app-video',
  imports: [CommonModule, ButtonComponent],
  template: `
    <div
      class="flex flex-col gap-6"
      [ngClass]="{
        'grid  sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 my-4 p-2 gap-4 items-stretch': training
      }"
    >
      <div
        *ngFor="let video of videos"
        class="flex flex-col h-full rounded-lg shadow-md"
      >
        <div class="h-[350px] sm:h-auto md:h-auto lg:h-auto">
          <img
            [src]="video.thumb"
            class="object-cover h-full w-full rounded-lg"
          />
        </div>
        <div
          class="p-4 text-center flex-1 flex flex-col gap-4 justify-between items-center"
        >
          <p class="text-xl flex-1">{{ video.title }}</p>
          <p class="text-[#616161] flex-1">
            {{ video.description }}
          </p>
          <div
            (click)="playVideo(video.title)"
            class="px-5 py-2 border border-[#043B22]/80 futura flex gap-3 align-middle items-center justify-center rounded-lg hover:bg-[#043B22]/80 hover:text-white cursor-pointer"
          >
            {{ locale.inform_step_3.button_play_now }}
          </div>
        </div>
        <div
          (click)="exitVideo(video.title)"
          class="fixed top-0 left-0 size-full bg-black/80 flex justify-center z-50"
          [ngClass]="{ visible: video.show, hidden: !video.show }"
        >
          <video
            controls
            width="1200"
            height="600"
            [id]="video.title"
            (pause)="(!video.show)"
            class="m-auto z-[100] rounded-lg"
            (click)="$event.preventDefault(); $event.stopPropagation()"
          >
            <source [src]="video.url" type="video/mp4" />
          </video>
          <div class="absolute bottom-30 w-[1200px]">
            <app-button>{{ locale.common.back }}</app-button>
          </div>
        </div>
      </div>
    </div>
  `
})
export class VideoComponent {
  @Input() training = false;
  @Input() videos: any = [];

  private localeService = inject(LocaleService);
  locale = this.localeService.locale();

  constructor() {
    effect(() => {
      this.locale = this.localeService.locale();
    });
  }

  playVideo = (title: string) => {
    this.videos.map((video: any) => {
      if (video.title === title) {
        video.show = true;
      } else {
        video.show = false;
      }
    });
  };

  exitVideo = (title: string) => {
    const video = document.getElementById(title);
    // @ts-ignore
    video.pause();
    // @ts-ignore
    video.currentTime = 0;
    this.videos.map((video: any) => {
      video.show = false;
    });
  };
}
